import Nav from "./Nav";
import styled from "styled-components";
import { Link } from "react-router-dom";
import AoneLogo from "../../resources/images/logo/aone_logo.png";
import { languageStore } from "../../state/language";
import LanguageSelection from "../contents/LanguageSelection";
import UseBreakpoints from "../hooks/ui/UseBreakpoints";
const Header = ({ children }) => {
  const lang = languageStore();
  const breakpoints = UseBreakpoints();
  return (
    <Div>
      <Inner>
        <LogoLink to="/" draggable={false} aria-label="관세법인 에이원 홈">
          <img src={AoneLogo} alt="A1 Customs & Trade Service" />
          {lang.language !== "EN" && (
            <span>
              관세법인 <b>에이원</b>
            </span>
          )}
        </LogoLink>
        <Nav />
        {breakpoints.xl && (
          <Utility>
            <Link to="/careers">{lang.language === "EN" ? "Careers" : "채용"}</Link>
            {/* <a className="pill" href="https://a1tcms.com" target="_blank" rel="noreferrer">
              A1 TCMS <span aria-hidden="true">↗</span>
            </a> */}
            <LanguageSelection />
          </Utility>
        )}
        {children}
      </Inner>
    </Div>
  );
};
export default Header;
const Div = styled.header`
  z-index: 10;
  height: ${({ theme }) => theme.layout.header};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  /* backdrop-filter 금지: fixed인 모바일 메뉴(Hamburger)의 기준이 헤더로 바뀌어 메뉴가 안 보인다 */
  background-color: white;
  border-bottom: 1px solid ${({ theme }) => theme.colors.line};
  & a {
    text-decoration: none;
    color: inherit;
  }
`;
const Inner = styled.div`
  height: 100%;
  max-width: 90rem;
  margin: 0 auto;
  padding: 0 clamp(1rem, 3vw, 2.5rem);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 2rem;
`;
const LogoLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.85rem;
  flex-shrink: 0;
  & > img {
    height: 2.5rem;
  }
  & > span {
    padding-left: 0.85rem;
    border-left: 1px solid ${({ theme }) => theme.colors.line};
    font-size: 0.95rem;
    color: ${({ theme }) => theme.colors.dark};
    white-space: nowrap;
    & > b {
      font-weight: 700;
    }
  }
  @media (max-width: 420px) {
    & > img {
      height: 2.1rem;
    }
    & > span {
      display: none;
    }
  }
`;
const Utility = styled.div`
  display: flex;
  align-items: center;
  gap: 1.1rem;
  flex-shrink: 0;
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.foreground.dimmed};
  & > a:hover {
    color: ${({ theme }) => theme.colors.accent};
  }
  & > a.pill {
    padding: 0.4rem 0.9rem;
    border-radius: 999px;
    border: 1px solid ${({ theme }) => theme.colors.dark};
    color: ${({ theme }) => theme.colors.dark};
    font-weight: 600;
    transition: background-color 0.2s, color 0.2s;
    &:hover {
      background-color: ${({ theme }) => theme.colors.dark};
      color: white;
    }
  }
`;
